import countries from '~/assets/constants/shopify/countries.json'
import {
  buildGlobaleParams,
  globaleAppScriptSrc,
  globaleStorefrontScriptSrc,
  resolveGlobaleCountry,
  resolveGlobaleEnvironment,
  serialiseGlobaleParams,
} from '~/assets/js/helpers/globale'

/**
 * Injects the Global-e headless scripts into <head> on every page.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const { globale, shopify } = useRuntimeConfig().public

  if (!globale?.enabled) return

  const environment = resolveGlobaleEnvironment(globale.environment)
  const shopifyStore = useShopifyStore()

  const script: Record<string, unknown>[] = []

  if (globale.merchantId) {
    script.push({
      id: 'ge-storefront-js',
      src: globaleStorefrontScriptSrc(environment),
      async: true,
      'data-mid': globale.merchantId,
      'data-env': environment,
      tagPriority: 2,
    })
  }

  const geoCountry = useGeoCountry()

  const localeCurrency = shopifyStore.country?.currency?.isoCode
  const sameCurrencyCountryCodes = countries
    .filter((country) => country.currency?.isoCode === localeCurrency)
    .map((country) => country.isoCode)

  const countryCode = resolveGlobaleCountry(
    nuxtApp.$i18n.localeProperties.value?.countryCode,
    geoCountry.value,
    sameCurrencyCountryCodes
  )

  const params = buildGlobaleParams(countryCode, shopifyStore.country?.currency?.isoCode)
  const appScriptSrc = globaleAppScriptSrc(environment, shopify?.storeDomain)

  if (params && appScriptSrc) {
    script.push(
      {
        id: 'glbe-params',
        type: 'text/javascript',
        innerHTML: serialiseGlobaleParams(params),
        tagPriority: 3,
      },
      {
        id: 'glbe-app-js',
        src: appScriptSrc,
        defer: true,
        tagPriority: 4,
      }
    )
  }

  if (script.length) useHead({ script })
})
